import { render, staticRenderFns } from "./HubConfigParam.vue?vue&type=template&id=2a618f7c&scoped=true&"
import script from "./HubConfigParam.vue?vue&type=script&lang=js&"
export * from "./HubConfigParam.vue?vue&type=script&lang=js&"
import style0 from "./HubConfigParam.vue?vue&type=style&index=0&id=2a618f7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a618f7c",
  null
  
)

export default component.exports